/**
 * Friendly / snake_case aliases → canonical catalog kind.
 */
export var PIPELINE_ALIASES = {
    // snake_case & common shorts
    service_task: 'serviceTask',
    user_task: 'userTask',
    manual_task: 'manualTask',
    script_task: 'scriptTask',
    business_rule: 'businessRule',
    exclusive_gateway: 'exclusiveGateway',
    xor_gateway: 'exclusiveGateway',
    xor: 'exclusiveGateway',
    parallel_gateway: 'parallelGateway',
    and_gateway: 'parallelGateway',
    inclusive_gateway: 'inclusiveGateway',
    or_gateway: 'inclusiveGateway',
    data_store: 'dataStore',
    data_object: 'dataObject',
    event_bus: 'eventBus',
    message_queue: 'messageQueue',
    mq: 'messageQueue',
    merge_request: 'mergeRequest',
    mr: 'mergeRequest',
    pull_request: 'pullRequest',
    pr: 'pullRequest',
    secret_vault: 'secretVault',
    vault: 'secretVault',
    sign_off: 'signOff',
    signoff: 'signOff',
    change_request: 'changeRequest',
    cr: 'changeRequest',
    change_order: 'changeOrder',
    assembly_station: 'assemblyStation',
    cnc_machine: 'cncMachine',
    cnc: 'cncMachine',
    production_line: 'productionLine',
    manufacturing_cell: 'manufacturingCell',
    raw_material: 'rawMaterial',
    work_in_progress: 'workInProgress',
    wip: 'workInProgress',
    finished_goods: 'finishedGoods',
    cargo_container: 'cargoContainer',
    shipping_container: 'cargoContainer',
    loading_dock: 'loadingDock',
    quality_control: 'qualityControl',
    qc: 'qualityControl',
    quality_assurance: 'qualityAssurance',
    qa_process: 'qualityAssurance',
    test_bench: 'testBench',
    functional_test: 'functionalTest',
    integration_test: 'integrationTest',
    unit_test: 'unitTest',
    performance_test: 'performanceTest',
    reliability_test: 'reliabilityTest',
    acceptance_test: 'acceptanceTest',
    cad_model: 'cadModel',
    block_diagram: 'blockDiagram',
    barcode_reader: 'barcodeReader',
    rfid_reader: 'rfidReader',
    iot_device: 'iotDevice',
    iot: 'iotDevice',
    virtual_machine: 'virtualMachine',
    vm: 'virtualMachine',
    container: 'appContainer',
    app_container: 'appContainer',
    kubernetes_cluster: 'kubernetesCluster',
    k8s: 'kubernetesCluster',
    kubernetes: 'kubernetesCluster',
    edge_device: 'edgeDevice',
    storage_system: 'storageSystem',
    ai_agent: 'aiAgent',
    ai: 'aiAgent',
    business_process: 'businessProcess',
    manufacturing_process: 'manufacturingProcess',
    engineering_process: 'engineeringProcess',
    software_process: 'softwareProcess',
    value_stream: 'valueStream',
    control_point: 'controlPoint',
    decision_point: 'decisionPoint',
    customer_delivery: 'customerDelivery',
    third_party_service: 'thirdPartyService',
    thirdparty: 'thirdPartyService',
    archive_storage: 'archiveStorage',
    db: 'database',
    database: 'database',
    kpi: 'kpi',
    api: 'api',
    mes: 'mes',
    erp: 'erp',
    crm: 'crm',
    hrms: 'hrms',
    hr: 'hrms',
    plc: 'plc',
    hmi: 'hmi',
    scada: 'scada',
    bom: 'bom',
    agv: 'agv',
    devops: 'cicd',
    ci_cd: 'cicd',
    ciCd: 'cicd',
    auth: 'authentication',
    authn: 'authentication',
    authz: 'authorization',
    encrypt: 'encryption',
    fw: 'firewall',
    notify: 'notification',
    mail: 'email',
    sms: 'phone',
    docs: 'document',
    doc: 'document',
    dir: 'folder',
    repo: 'repository',
    git: 'repository',
    build_job: 'build',
    deploy_job: 'deploy',
    prod: 'production',
    stg: 'staging',
    stage: 'staging',
    dev: 'development',
    test_env: 'testing',
    eng: 'engineer',
    tech: 'technician',
    mgr: 'manager',
    ops: 'operator',
    vendor_org: 'vendor',
    supplier_org: 'supplier',
    ok: 'success',
    fail: 'failure',
    warn: 'warning',
    info: 'information',
    prio: 'priority',
    swim_lane: 'swimlane',
    ext: 'externalSystem',
    www: 'internet',
    web: 'internet',
    factory_plant: 'factory',
    production_factory: 'factory',
    warehouse_building: 'warehouse',
    bike_cycle: 'cycle',
    bicycle: 'cycle',
    motorcycle: 'bike',
    auto_rickshaw: 'autoVehicle',
    autorickshaw: 'autoVehicle',
    rickshaw_auto: 'autoVehicle',
    aeroplane: 'flight',
    airplane: 'flight',
    plane: 'flight',
    wifi_signal: 'wifi',
    wi_fi: 'wifi',
    cell_tower: 'phoneTower',
    mobile_tower: 'phoneTower',
    solar: 'solarPanel',
    hills: 'hillStation',
    hill: 'hillStation',
    rupees: 'rupee',
    inr: 'rupee',
    usd: 'dollar',
    eur: 'euro',
    envelope_mail: 'envelope',
    malware: 'virus',
    software_bug: 'bug',
    elevator: 'lift',
    stairs: 'staircase',
    parking_lot: 'parking',
    house: 'home',
    office_building: 'building',
};
